// ─── Firebase Configuration (v8 compat) ──────────────────────────────────────
// 1. Go to https://console.firebase.google.com
// 2. Create a project → Add app → Web
// 3. Copy your config object here
// 4. Enable Firestore: Build → Firestore Database
// 5. Enable Storage:   Build → Storage

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

const firebaseConfig = {
 
  apiKey: "AIzaSyDSVzOz1soDChw6u3Mg0erJ3yTRuc2CShk",
  authDomain: "good-vibes-store.firebaseapp.com",
  projectId: "good-vibes-store",
  storageBucket: "good-vibes-store.firebasestorage.app",
  messagingSenderId: "1088660023223",
  appId: "1:1088660023223:web:0ebbd6821dff11a00c6a32"
};

// Prevent re-initializing on hot reload
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const db      = firebase.firestore();
export const storage = firebase.storage();
export const auth    = firebase.auth();
export default firebase;
